import { ToolboxItem, ToolboxItemType } from '@occc-app/design-system';
import { useConfig } from '@occc/config';

import { routeCreator } from '../triggered-messages.utils';

export const TriggeredMessagesToolboxItem = () => {
  const { config } = useConfig();
  const subBrands = config.subBrands?.enabled ? config.subBrands.list : [];
  const defaultSubbrandUuid = subBrands[0]?.uuid;

  return (
    <ToolboxItem
      title='Triggered Messages'
      description='Engage with customers at key points in their journey with triggered messages'
      type={ToolboxItemType.TriggeredMessages}
      linkToDetails={
        defaultSubbrandUuid
          ? routeCreator.listByScope.to(defaultSubbrandUuid)
          : routeCreator.list.to()
      }
    />
  );
};
